var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStarFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A2B94A3A-7952-4BD5-85BC-A092EFFD14B3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-no-data",
    transform: "translate(-393.000000, -1098.000000)",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Info",
    transform: "translate(100.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cost-center",
    transform: "translate(0.000000, 520.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_star_filled",
    transform: "translate(292.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    points: "9.32296704 9 12 2.3074176 14.677033 9 22.8507811 9 16.2040022 14.3174231 19.030933 21.3847502 12 17.1661904 4.96906696 21.3847502 7.7959978 14.3174231 1.14921894 9"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStarFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_star_filled.ef95ea6a5d66cf971d1104c7c1a8f1d0.svg";